import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getRandomID } from '@mdc/services';
import ReactTooltip from 'react-tooltip';
import { renderToStaticMarkup } from 'react-dom/server';

import './DataPreviewTooltip.scss';

const DataPreviewTooltip = ({ content, customClassName }) => {
    const [tooltipId] = useState(getRandomID(9));

    const toolTipContent = <span className='dataPreviewTooltipContent'>
        {content}
    </span>;

    return <React.Fragment>
        <span data-tip={renderToStaticMarkup(toolTipContent)} data-for={tooltipId} className={customClassName}>
            <div>{content}</div>
        </span>
        <ReactTooltip id={tooltipId} html={true} className='dataPreviewTooltip'/>
    </React.Fragment>;
};

DataPreviewTooltip.propTypes = {
    content: PropTypes.string.isRequired,
    customClassName: PropTypes.string
};

export default DataPreviewTooltip;
